export default __webpack_public_path__ + "static/media/no-position.b288016b.png";